import {get} from "../../middleware/api-proxy";

export class DataService {
  static async getData(zip: string, category: string) {
    return await get(`/root-data/data/${zip}/${category}`)
  }
}